export default "__VITE_ASSET__BIdAPOQv__"